import { WithNAFallback } from '@design';
import { formatPercentage, formatPriceWithCurrency } from '@helpers';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './TargetItem.module.scss';

interface TargetItemProps {
  titleKey: string;
  value?: number;
  isNegative: boolean;
  isActive?: boolean;
  changeValue?: number;
  showChange?: boolean;
  currency?: string;
}

export const TargetItem = ({
  titleKey,
  value,
  isNegative,
  isActive = false,
  changeValue,
  showChange = false,
  currency,
}: TargetItemProps) => {
  const { t } = useTranslation(['earnings']);

  const changeIsNegative = (changeValue ?? 0) < 0;

  return (
    <div
      className={clsx(styles.targetWrapper, {
        [styles.targetWrapperActive]: isActive,
        [styles.targetWrapperInactive]: !isActive,
      })}
    >
      <div className={isActive ? styles.targetTitleActive : styles.targetTitle}>
        {t(`earnings:earningsInsight.drawer.earningsPreview.${titleKey}`)}
      </div>
      {showChange ? (
        <div className={styles.averageTargetRow}>
          <WithNAFallback
            value={
              <div
                className={clsx(
                  isActive ? styles.targetValueActive : styles.targetValue,
                  isNegative ? styles.valueBearish : styles.valueBullish
                )}
              >
                {formatPriceWithCurrency(value ?? 0, currency)}
              </div>
            }
            check={!!value}
            useFallbackDash
          />
          <WithNAFallback
            value={
              <div
                className={clsx(
                  styles.changeLabel,
                  changeIsNegative ? styles.changeBearish : styles.changeBullish
                )}
              >
                {formatPercentage(changeValue ?? 0, {
                  suffix: '%',
                  addPlus: true,
                })}
              </div>
            }
            check={changeValue !== undefined}
            useFallbackDash
          />
        </div>
      ) : (
        <WithNAFallback
          value={
            <div
              className={clsx(
                isActive ? styles.targetValueActive : styles.targetValue,
                isNegative ? styles.valueBearish : styles.valueBullish
              )}
            >
              {formatPriceWithCurrency(value ?? 0, currency)}
            </div>
          }
          check={!!value}
          useFallbackDash
        />
      )}
    </div>
  );
};
